//路由配置

import Layout from '@/pages/Layout'
import Login from '@/pages/Login'
import { AuthRoute } from '@/components/AuthRoute'

import { createBrowserRouter } from 'react-router-dom'

import ProjectUpload from '@/pages/ProjectManage/pages/ProjectUpload'
import { usePermission, PermissionProvider } from '@/hooks/usePermission'
import ProjectDisplay from '@/pages/ProjectManage/pages/ProjectDisplay'
import ProjectDetail from '@/pages/ProjectManage/pages/ProjectDisplay/components/ProjectDetail'
import MapComponent from '@/utils/Map'

import ShowLocationUpload from '@/pages/ShowLocation/pages/ShowLocationUpload'
import ShowLocationDisplay from '@/pages/ShowLocation/pages/ShowLocationDisplay'
import ShowLocationDetail from '@/pages/ShowLocation/pages/ShowLocationDetail'
import MyShowLocationDisplay from '@/pages/ShowLocation/pages/MyShowLocationDisplay'
import MyShowLocationDetail from '@/pages/ShowLocation/pages/MyShowlocationDetail'

import ProjectDetailForms from '@/pages/Forms/components/ProjectDetailForms'
import HistoryFlyForms from '@/pages/Forms/components/HistoryFlyForms'

import UserRegister from '@/pages/CompanyManage/pages/UserRegister'
import AccountManage from '@/pages/CompanyManage/pages/AccountManage'
import CompanyUpload from '@/pages/CompanyManage/pages/CompanyUpload'
import CompanyDisplay from '@/pages/CompanyManage/pages/CompanyDisplay'
import CompanyDetail from '@/pages/CompanyManage/pages/CompanyDisplay/pages/CompanyDetail'
import DepartmentDisplay from '@/pages/CompanyManage/pages/CompanyDisplay/pages/DepartmentDisplay'
import DepartmentDetail from '@/pages/CompanyManage/pages/CompanyDisplay/pages/DepartmentDetail'

import FileManage from '@/pages/FileManage'

import DesignResUpload from '@/pages/DesignRes/pages/DesignResUpload'
import DesignResDisplay from '@/pages/DesignRes/pages/DesignResDisplay'
import DesignResDetail from '@/pages/DesignRes/pages/DesignResDetail'
import PointCloud from '@/pages/DesignRes/pages/DesignResDetail/PointCloud'
import BlenderResourceUpload from '@/pages/BlenderResourceManage/pages/BlenderResourceUpload'
import BlenderResourceDisplay from '@/pages/BlenderResourceManage/pages/BlenderResourceDisplay'
import DanceStepCutTransfer from '@/pages/DesignRes/pages/DanceStepCutTransfer'
import UserLogPage from '@/pages/UserLog'
import LicenseList from '@/pages/LicenseManage/LicenseList'
import LicenseAdd from '@/pages/LicenseManage/LicenseAdd'
import SoftwareUpdateUpload from '@/pages/SoftwareUpdateManage/SoftwareUpdateUpload'
import SoftwareUpdateList from '@/pages/SoftwareUpdateManage/SoftwareUpdateList'

//配置路由实例

const PermissionWrapper = ({ code, children }) => {
    const { has, loading } = usePermission();
    if (loading) return null; // 可加骨架屏
    return has(code) ? <>{children}</> : <div style={{padding:32}}>无访问权限: {code}</div>;
};

const router = createBrowserRouter([
    {
        path: "/",
    element: <AuthRoute><PermissionProvider><Layout /></PermissionProvider></AuthRoute>,
        // element: <Layout/> ,
        children: [
            {
                path: 'BlenderResourceUpload',
                element: <BlenderResourceUpload />,
            },
            {
                path: 'BlenderResourceDisplay',
                element: <BlenderResourceDisplay />,
            },
            {
                path: 'DanceStepCutTransfer',
                element: <DanceStepCutTransfer />,
            },
            {
                path: 'ProjectUpload',
                element: <PermissionWrapper code="ProjectUpload"><ProjectUpload /></PermissionWrapper>,
            },
            {
                path: 'ProjectDisplay',
                element: <PermissionWrapper code="ProjectDisplay"><ProjectDisplay /></PermissionWrapper>,
            },
            {
                path: 'ProjectDetail',
                element: <ProjectDetail />
            },
            {
                path: 'Map',
                element: <MapComponent />
            },
            {
                path: 'ShowLocationUpload',
                element: <ShowLocationUpload />
            },
            {
                path: 'ShowLocationDisplay',
                element: <ShowLocationDisplay />
            },
            {
                path: 'ShowLocationDetail',
                element: <ShowLocationDetail />
            },
            {
                path: 'MyShowLocationDisplay',
                element: <MyShowLocationDisplay />
            },
            {
                path: 'MyShowLocationDetail',
                element: <MyShowLocationDetail />
            },
            {
                path: 'DesignResUpload',
                element: <DesignResUpload />
            },
            {
                path: 'DesignResDisplay',
                element: <DesignResDisplay />
            },
            {
                path: 'DesignResDetail',
                element: <DesignResDetail />
            },
            {
                path: 'CompanyUpload',
                element: <CompanyUpload />
            },
            {
                path: 'CompanyDisplay',
                element: <CompanyDisplay />

            },
            {
                path: 'CompanyDetail',
                element: <CompanyDetail />

            },
            {
                path: 'AccountManage',
                element: <AccountManage />

            },
            {
                path: 'UserRegister',
                element: <UserRegister />

            },
            {
                path: 'DepartmentDisplay',
                element: <DepartmentDisplay />
            },
            {
                path: 'DepartmentDetail',
                element: <DepartmentDetail />
            },
            {
                path: 'FileManage',
                element: <FileManage />
            },
            {
                path: 'PointCloud',
                element: <PointCloud />
            },
            {
                index: true,
                path: 'ProjectDetailForms',
                element: <ProjectDetailForms />
            },
            {
                path: 'HistoryFlyForms',
                element: <HistoryFlyForms />
            },
            {
                path: 'UserLogs',
                element: <UserLogPage />
            },
            {
                path: 'LicenseList',
                element: <LicenseList />
            },
            {
                path: 'LicenseAdd',
                element: <LicenseAdd />
            },
            {
                path: 'SoftwareUpdateUpload',
                element: <SoftwareUpdateUpload />
            },
            {
                path: 'SoftwareUpdateList',
                element: <SoftwareUpdateList />
            },
        ]
    },
    {
        path: "/login",
        element: <Login />
    },
])

export default router